import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5edd477e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-a-overview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Overview", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_5 = { class: "shade mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice Name:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Practice Trading Name:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Relevant Period:", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice business structure:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "We have on record the following details for your Law Practice:", -1))
const _hoisted_13 = { class: "shade" }
const _hoisted_14 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_15 = { class: "branches ml-2" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "branch-name" }, "Branch Address:", -1))
const _hoisted_19 = { class: "branch-address" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "branch-name" }, "Branch Trading Name:", -1))
const _hoisted_22 = { class: "branch-address" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Commencement Date:", -1))
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Cessation Date:", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mt-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle fa-lg mr-2" }),
  /*#__PURE__*/_createTextVNode(" If the information recorded above is incorrect or incomplete, please notify the Registry Department at "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    target: "blank",
    href: "mailto:registry@lawsociety.com.au"
  }, "registry@lawsociety.com.au"),
  /*#__PURE__*/_createTextVNode(".")
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent.firmName) + " / " + _toDisplayString(_ctx.overviewContent.firmId), 1),
            _hoisted_7,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.practiceTradingName?? 'No trading name found'), 1),
            _hoisted_8,
            (!_ctx.overviewContent?.complianceYearStart)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearStart) || '-') + " - " + _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearEnd) || '-'), 1)
                ])),
            _hoisted_11,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.lawPracticeStructure), 1)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_ctx.overviewContent?.otherBranches?.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "No Branches found"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewContent.otherBranches, (b, i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(b?.branchAddress ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(b?.tradingName ?? 'No trading name found'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", null, _toDisplayString(_ctx.$formatDateFullDate(b.periodFrom) || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(_ctx.$formatDateFullDate(b.periodTo) || '-'), 1)
                  ])
                ]),
                ((i+1) != _ctx.overviewContent?.otherBranches?.length)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_28))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]),
          _hoisted_29
        ], 64))
      : _createCommentVNode("", true)
  ]))
}